const i = "Notification", t = "Critical notification", o = "Close notification", c = {
  notification: i,
  criticalNotification: t,
  close: o
};
export {
  o as close,
  t as criticalNotification,
  c as default,
  i as notification
};
